import { render, staticRenderFns } from "./DocumentRepository.vue?vue&type=template&id=240089b5&scoped=true&"
import script from "./DocumentRepository.vue?vue&type=script&lang=js&"
export * from "./DocumentRepository.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRepository.vue?vue&type=style&index=0&id=240089b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240089b5",
  null
  
)

export default component.exports